import type { ChartType, ChartSex, PercentileCurvePoint } from './types'
import { weightForAgeBoys, weightForAgeGirls } from './weightForAge'
import { heightForAgeBoys, heightForAgeGirls } from './heightForAge'
import { bmiForAgeBoys, bmiForAgeGirls } from './bmiForAge'
import {
  headCircumferenceForAgeBoys,
  headCircumferenceForAgeGirls
} from './headCircumferenceForAge'

export function getWhoData(
  type: ChartType,
  sex: ChartSex
): PercentileCurvePoint[] {
  const isMale = sex === 'M'
  switch (type) {
    case 'weightForAge':
      return isMale ? weightForAgeBoys : weightForAgeGirls
    case 'heightForAge':
      return isMale ? heightForAgeBoys : heightForAgeGirls
    case 'bmiForAge':
      return isMale ? bmiForAgeBoys : bmiForAgeGirls
    case 'headCircumferenceForAge':
      return isMale
        ? headCircumferenceForAgeBoys
        : headCircumferenceForAgeGirls
  }
}

export interface AxisConfig {
  yLabel: string
  unit: string
  yMin: number
  yMax: number
  visitField: string
}

export const axisConfig: Record<ChartType, AxisConfig> = {
  weightForAge: {
    yLabel: 'Weight (kg)',
    unit: 'kg',
    yMin: 0,
    yMax: 28,
    visitField: 'weight'
  },
  heightForAge: {
    yLabel: 'Length/Height (cm)',
    unit: 'cm',
    yMin: 40,
    yMax: 125,
    visitField: 'height'
  },
  bmiForAge: {
    yLabel: 'BMI (kg/m²)',
    unit: 'kg/m²',
    yMin: 8,
    yMax: 26,
    visitField: 'bmi' // derived
  },
  headCircumferenceForAge: {
    yLabel: 'Head Circumference (cm)',
    unit: 'cm',
    yMin: 28,
    yMax: 56,
    visitField: 'ofc'
  }
}

export type { ChartType, ChartSex, PercentileCurvePoint, PatientDataPoint } from './types'
